// extracted by mini-css-extract-plugin
export default {"container":"TotalRow-container_Y5ixY","total":"TotalRow-total_c02Or"};